module.exports = __webpack_public_path__ + "static/livro-2-2cba9a99106ddf7dd8d16b54d316b484.png";